export const MTU = 1200;
